import {Component, Inject, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormGroup} from '@angular/forms';
import {MotivoFormComponent} from '../motivo-form/motivo-form.component';

@Component({
    selector: 'app-motivo-cancelacion-diligencia',
    templateUrl: './motivo-cancelacion-create.component.html',
    styleUrls: ['./motivo-cancelacion-create.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class MotivoCancelacionCreateComponent implements OnInit {

    public form: FormGroup;
    public title = 'Motivo de cancelación';
    public nameButonSaveOrUpdate = 'Guardar';

    @ViewChild(MotivoFormComponent, {static: false})
    set formComponent(formMotivo: MotivoFormComponent) {
        this.form = formMotivo.form;
        this.nameButonSaveOrUpdate = 'Guardar';
    }

    constructor(
        public dialogRef: MatDialogRef<MotivoCancelacionCreateComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
    }

    public get formValid() {
        return this.form !== undefined && this.form.valid;
    }

    public save() {
        this.dialogRef.close(this.form.value);
    }
}
